<template>
  <div>
    <mdb-modal removeBackdrop centered @close="$store.commit('clearCurrentModal')" elegant>
      <mdb-modal-header>
        <mdb-modal-title class="isi-heading-blue"
          >Reset Password</mdb-modal-title
        >
      </mdb-modal-header>
      <mdb-modal-body>
        <p class="mb-4 mt-n3">
          Please type in your email address so we can send a password reset
          link.
        </p>
        <form v-on:submit.prevent v-on:keyup.enter="sendMail">
          <div class="grey-text">
            <mdb-input label="Your email" v-model="email" outline />
          </div>
          <validation-info :text="validationInfo" />
          <div class="text-center">
            <mdb-btn class="btn btn-isi" @click="sendMail">Send</mdb-btn>
          </div>
        </form>
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
import ValidationInfo from "../ValidationInfo.vue";

export default {
  components: {
    ValidationInfo,
  },
  data() {
    return {
      email: null,
      password: null,
      validationInfo: "",
    };
  },
  methods: {
    sendMail() {
      if (!this.email) {
        this.validationInfo = "Please type in your email address.";
        return;
      }
      // simple check for frontend
      if (!/\S+@\S+\.\S+/.test(this.email)) {
        this.validationInfo = "Please provide a valid email address.";
        return;
      }
      this.validationInfo = "";

      this.$http
        .post("/api/UserAction/ForgotPassword", { email: this.email })
        .then(() => {
          this.$store.commit("setCurrentModal", {
            type: "generalInfoModal",
            options: {
              title: "Password link sent",
              content:
                "A password reset link has been sent to your email address.",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
